import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';

import { Response, OfferCarrierTitle, OfferCarrierTitleSearchRequest } from '@core/api';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OfferCarrierTitleService {
  constructor(private http: HttpClient) { }

  search(request: OfferCarrierTitleSearchRequest): Observable<Response<OfferCarrierTitle[]>> {
    return this.http.post<Response<OfferCarrierTitle[]>>(environment.apiUrl + '/api/OfferCarrierTitle/Search', request);
  }
}
